<template>
  <v-dialog v-model="confirmClient.show" :width="450" persistent>
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line="true"
        :timeout="3000" >
      {{ snackbar.message }}
    </v-snackbar>
    <LoadingDialog v-model="showLoadingDialog" />

    <v-card v-if="confirmClient.client">
      <v-card-title class="pb-0">
        <div class="add-on-heading">
          <div class="add-on-title txt-bold itoviEden--text" style="font-size: 24px;">
            {{ confirmClient.client.expires_on ? 'Reactivate' : 'Remove'}} Contact
          </div>
          <span flat icon color="itoviGrayMid" @click="close()"><v-icon>close</v-icon></span>
        </div>
      </v-card-title>
      <v-card-text class="text-sm-center" v-if="confirmClient.client.expires_on">
        Are you sure you’d like to activate {{ confirmClient.client.name }}? They will appear in your contact list and you will pay $2.99 for them your next billing cycle.
      </v-card-text>
      <v-card-text class="text-sm-center" v-else>
        Are you sure you want to remove {{ confirmClient.client.name }}? They will be removed from your contacts and unable to receive scans starting {{ nextPayment.date}}.
      </v-card-text>
      <v-layout class="pa-3" row justify-center align-center>
        <div class="mr-2">
          <button class="button-gray-outline" @click="close()">Cancel</button>
        </div >
        <div class="ml-2">
          <button @click="confirmChange" :class="confirmClient.client.expires_on ? 'button-blue' : 'button-red'" :disabled="showLoadingDialog">
            {{ confirmClient.client.expires_on ? 'Confirm' : 'Remove'}}
          </button>
        </div>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
  import store from "@/store";
  import subscribeToStore from "@/mixins/subscribeToStore";
  import api from '@/services/api_endpoints';
  import LoadingDialog from "@/components/LoadingDialog";

  export default {
    data: () => ({
      planDetails: store.state.planDetails,
      nextPayment: store.state.nextPayment,
      showLoadingDialog: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }),
    props: [
        'confirmClient',
        'fetchData',
        'activeClient'
    ],
    components: {
      LoadingDialog
    },
    mixins: [subscribeToStore],
    mounted() {
      this.subscribeToStore(['planDetails', 'nextPayment']);
    },
    methods: {
      async confirmChange() {
        this.showLoadingDialog = true;
        let planResult = false;
        let plusOneResult = true;
        const planCount = parseInt(this.planDetails.product_code.split('+')[1]);
        const newPlanCount = this.confirmClient.client.expires_on ? planCount + 1 : planCount - 1;
        const newPlan = this.planDetails.family_plans.filter((plan) => plan.product_code.split('+')[1] == newPlanCount)[0];

        if (!newPlan) {
          this.showLoadingDialog = false;
          return this.showSnackBar('danger', 'Unable to process your request at this time.')
        }

        if (planCount > newPlanCount && this.confirmClient.client.id !== -1) {
          plusOneResult = await api.deletePlusOne(this.confirmClient.client.id);
        }

        if (plusOneResult) {
          planResult = await api.submitPlanChange(newPlan.product_code);
        }

        if (planResult.success && planCount < newPlanCount) {
          plusOneResult = await api.assignPlusOne(this.confirmClient.client.id);
        }

        await this.fetchData();
        this.showLoadingDialog = false;

        if (plusOneResult && planResult.success) {
          this.$emit('update:activeClient',null);
          this.close();
          return;
        }

        this.showSnackBar('danger', planResult.errorMessage ? planResult.errorMessage : 'Unable to process your request at this time.');
      },
      showSnackBar(color, message) {
       this.snackbar = {
          show: true,
          color: color,
          message: message,
        };
      },
      close() {
        this.$emit('update:confirmClient',{
          show: false,
          client: null
        });
      }
    }
  }
</script>
